import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  return config;
});

let refreshRequest;
api.interceptors.response.use((response) => response, async (error) => {
  const config = error.config;
  if (error.response?.status !== 401 || !config || config._retried || config.url?.startsWith("/auth/")) throw error;
  config._retried = true;
  refreshRequest ||= api.post("/auth/refresh").finally(() => { refreshRequest = null; });
  await refreshRequest;
  return api(config);
});

export function errMsg(error, fallback = "Etwas hat nicht funktioniert. Bitte versuche es erneut.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d?.msg === "string" ? d.msg : "")).filter(Boolean).join(" ") || fallback;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}

export function fileUrl(value) {
  if (!value) return null;
  if (typeof value !== "string") return null;
  if (value.startsWith("http") || value.startsWith("data:")) return value;
  if (value.startsWith("/api/")) return `${BASE}${value}`;
  return value;
}
